import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PlanUsage',
  props: {
    label: null,
    rangeMax: null,
    rangeValue: null
  },
  setup(__props: any) {

const props = __props as { label: string; rangeMax: string; rangeValue: string }



return { __sfc: true,props }
}

})